// extracted by mini-css-extract-plugin
export const link = "card-centred-module--link--hH94c";
export const fakeLink = "card-centred-module--fakeLink--2AhxL";
export const container = "card-centred-module--container--2oitw";
export const svgContainer = "card-centred-module--svgContainer--29ZcH";
export const svgBox = "card-centred-module--svgBox--1BjVl";
export const title = "card-centred-module--title--1oN_R";
export const copy = "card-centred-module--copy--3ZRrE";